// ---------------------------------------------------------------------------
// ชำระเงินออนไลน์ — ค่าเริ่มต้น/ตัวช่วยล้วน ๆ (ไม่แตะฐานข้อมูล เทสได้ตรง ๆ)
// ---------------------------------------------------------------------------
import { resolveSubscription } from "./plans";

export const ONLINE_PAYMENT_MODULE = "online_payment";
export const SETTINGS_KEY = "online_payment";

export const DEFAULT_SETTINGS = { enabled: true, linkExpireDays: 7, thankYou: "" };
export const EXPIRE_DAYS_MIN = 1;
export const EXPIRE_DAYS_MAX = 90;
export const THANK_YOU_MAX = 300;

/** ทำความสะอาดค่าตั้งก่อนบันทึก/ก่อนใช้ */
export const normalizeSettings = (input) => {
  const days = Math.round(Number(input?.linkExpireDays));
  return {
    enabled: input?.enabled === undefined || input?.enabled === null ? DEFAULT_SETTINGS.enabled : !(input.enabled === false || input.enabled === "false"),
    linkExpireDays: Number.isFinite(days) ? Math.min(EXPIRE_DAYS_MAX, Math.max(EXPIRE_DAYS_MIN, days)) : DEFAULT_SETTINGS.linkExpireDays,
    thankYou: String(input?.thankYou || "").slice(0, THANK_YOU_MAX),
  };
};

const CODE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/** รหัสลิงก์เดายาก: PL + 10 ตัว (ตัด I O 0 1) */
export const newLinkCode = () => {
  const bytes = new Uint8Array(10);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else bytes.forEach((_, i) => { bytes[i] = Math.floor(Math.random() * 256); });
  return `PL${Array.from(bytes, (b) => CODE_CHARS[b % CODE_CHARS.length]).join("")}`;
};

export const CODE_PATTERN = /^PL[A-Z0-9]{4,20}$/i;

/** URL ลิงก์ที่ส่งให้ลูกค้า (โดเมนเดียวกับเว็บที่เปิดอยู่) */
export const payUrl = (code, origin) => `${origin || (typeof window !== "undefined" ? window.location.origin : "")}/pay/${code}`;

/** สถานะที่แสดงจริง — active ที่เลยวันหมดอายุแล้วนับเป็น expired */
export const effectiveLinkStatus = (link, now = new Date()) => {
  if (!link) return "";
  if (link.status === "active" && link.expireAt && new Date(link.expireAt) < now) return "expired";
  return link.status;
};

/** ลิงก์ที่ลูกค้าเปิดสร้าง QR แล้วแต่ยังไม่ยืนยันเงินเข้า -> ให้ร้านกดตรวจสอบสถานะได้ */
export const isPendingLink = (link, now = new Date()) =>
  !!link?.pendingTransactionId && link.status === "active" && effectiveLinkStatus(link, now) === "active";

export const addDaysIso = (days, from = new Date()) => new Date(from.getTime() + days * 86400000).toISOString();

/**
 * ยอดรอโอนให้ร้าน — เงินที่ลูกค้าจ่ายผ่านลิงก์เข้าแพลตฟอร์มก่อน ทีมงานโอนให้ร้านตามรอบ
 * ทีมงานตั้ง payoutStatus = "transferred" (+ payoutAt, payoutRef) ที่ชีต payment_links · ค่าว่าง = รอโอน
 */
export const payoutSummary = (links) => {
  const paid = (links || []).filter((row) => row.status === "paid");
  const sum = (rows) => Math.round(rows.reduce((total, row) => total + (Number(row.amount) || 0) * 100, 0)) / 100;
  const transferred = paid.filter((row) => row.payoutStatus === "transferred");
  const waiting = paid.filter((row) => row.payoutStatus !== "transferred");
  return {
    waitingAmount: sum(waiting),
    waitingCount: waiting.length,
    transferredAmount: sum(transferred),
    transferredCount: transferred.length,
    totalAmount: sum(paid),
  };
};

/** ร้านรับชำระออนไลน์ได้ไหม — อ่านจากข้อมูลร้านสาธารณะ (plan/addons/enabledModules) + ค่าตั้งของร้าน */
export const onlinePaymentAvailable = (shop, settings) => {
  if (!shop) return false;
  const sub = resolveSubscription(shop);
  if (!sub.isActive || !sub.modules.includes(ONLINE_PAYMENT_MODULE)) return false;
  if (Array.isArray(shop.enabledModules) && !shop.enabledModules.includes(ONLINE_PAYMENT_MODULE)) return false;
  return normalizeSettings(settings).enabled;
};
